import type { TransitionEvent } from 'react'

import { ButtonContentLink } from '@fukku/button/ContentLink'
import type { LeaveAgentQueue } from '../../types/messageTypes'

import { cx } from 'utils/cx'
import { useChatBotMessages } from '../../hooks/useChatBotMessages'
import { ConversationTrigger } from '../../types/AIResponseTypes'
import styles from './LeaveAgentQueueButton.module.scss'

export const LeaveAgentQueueButton = ({
	message,
}: { readonly message: LeaveAgentQueue }) => {
	const { sendHumanMessage, deleteChoices, shouldFadeoutMessages } =
		useChatBotMessages()

	const title = message.elements.title

	const handleLeaveQueueClick = () => {
		sendHumanMessage({ messageContent: title })
		deleteChoices({ conversationTrigger: ConversationTrigger.EndConversation })
	}

	const onLeaveAgentQueueTransitionEnd = (
		e: TransitionEvent<HTMLButtonElement>
	): void => {
		if (e.propertyName === 'opacity') {
			deleteChoices()
		}
	}

	return (
		<ButtonContentLink
			className={cx(
				styles.leaveAgentQueueButton,
				shouldFadeoutMessages && styles.hidden
			)}
			onClick={handleLeaveQueueClick}
			onTransitionEnd={onLeaveAgentQueueTransitionEnd}
		>
			{title}
		</ButtonContentLink>
	)
}
